import React, { useState } from 'react';
import './Venue.scss';
import { Link } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import video from '../../assets/video/video.mp4';

const Venue = () => {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  return (
    <div className="venue">
      <div className="left-container">
        <p className="title">Mesto održavanja</p>
        <a href="https://www.hotelzlatibor-resort.com/" className="sub-title">
          HOTEL ZLATIBOR
        </a>

        <div className="sub-title" style={{ marginTop: '20px', fontSize: '17px' }}>
          O KONFERENCIJI DOT2026
        </div>
        <p className="text">
          {`Dvanaesta konferencija DOT industrije osiguranja biće održana od 5. do 7. oktobra na
          Zlatiboru u hotelu Zlatibor. "DOT" je tradicionalna i najstarija konferencija Udruženja
          osiguravača Srbije i održava se redovno od 2013. godine. Konferencija okuplja domaće i
          strane stručnjake iz oblasti informacionih tehnologija koji rade za industriju osiguranja,
          te stoga predstavlja jedinstveni IT događaj ovog tipa u zemlji i regionu koji je u
          potpunosti posvećen samo temama iz oblasti osiguranja kroz prizmu digitalizacije. Skup se
          organizuje u saradnji IT i poslovnih sektora osiguranja tako da će skup osim što je
          namenjen različitim IT stručnjacima, biti tematski proširen za predstavnike poslovnih
          sektora kompanija.`}
        </p>

        {/* <div className="btn-container">
          <Link
            to={'/accommodation'}
            style={isHovering ? { color: '#0D4077' } : {}}
            className="btn">
            POGLEDAJTE VIŠE
          </Link>
        </div> */}
      </div>
      <div className="right-container">
        <div className="image-wrapper">
          {/* <Link to={'/accommodation'}> */}
          <video
            className="video"
            autoPlay={true}
            muted={true}
            playsInline={true}
            loop={true}
            height="500px"
            src={video}
          />
          {/* </Link> */}
        </div>
        {/* <div className="btn-container-mobile">
          <Link
            to={'/accommodation'}
            style={isHovering ? { color: '#0D4077' } : {}}
            className="btn-mobile">
            POGLEDAJTE VIŠE
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default Venue;
